import { apiClient } from 'pobble-components/dist/api'

const apiGetSchoolData = (id, params) =>
  apiClient.get(`v3/schools/${id}`, { params: params })

const apiCreateGroup = (schoolId, data, params) =>
  apiClient.post(`/v3/schools/${schoolId}/groups`, data, { params })

const apiDeleteGroup = id => apiClient.delete('v3/groups', { data: { id } })

const apiUpdateGroup = (data, params) =>
  apiClient.put('v3/groups', data, { params })

const apiGetSchoolConflicts = schoolId =>
  apiClient.get(
    `/v3/schools/${schoolId}/pull_provider_operations/student_conflict_resolution`
  )

const apiResolveConflict = (schoolId, data) =>
  apiClient.post(
    `/v3/schools/${schoolId}/pull_provider_operations/student_conflict_resolution`,
    data
  )

export {
  apiGetSchoolData,
  apiCreateGroup,
  apiDeleteGroup,
  apiUpdateGroup,
  apiGetSchoolConflicts,
  apiResolveConflict
}
